import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import '../../services/remote-setup';
import ErrorBoundary from '../../common/ui/error-boundary';
import { NO_OP } from '../../common/utils';
import useRemoteModule from '../../services/use-remote-module';
const InternalRemoteComponent = ({
  analyticsChannel,
  remotePlugin,
  exportName = 'default',
  children = null,
  Fallback = null,
  ...componentProps
}) => {
  const [, setError] = useState();
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  useEffect(() => {
    const analyticsEvent = createAnalyticsEvent({
      action: 'rendered',
      actionSubject: 'remoteModule',
      actionSubjectId: 'remoteComponent',
      attributes: {
        exportName,
        dimensions: remotePlugin.dimensions,
        plugin: remotePlugin.constructor.name
      }
    });
    analyticsEvent.fire(analyticsChannel);
  }, [analyticsChannel, createAnalyticsEvent, exportName, remotePlugin]);
  const onError = useCallback(error => {
    // this is a workaround to throw an error from an async function
    setError(() => {
      throw error;
    });
  }, []);
  const remoteFrontendSdk = useRemoteModule(remotePlugin, {
    analyticsChannel,
    onError,
    onEvent: componentProps.onEvent
  });
  useEffect(() => {
    return () => {
      void remoteFrontendSdk.renderUfoExperience.abort({
        metadata: {
          moduleName: remoteFrontendSdk.getModuleName()
        }
      });
    };
  }, [remoteFrontendSdk]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, remoteFrontendSdk.renderComponent(exportName, componentProps, Fallback, children, remoteFrontendSdk.renderUfoExperience, componentProps.onEvent));
};
const RemoteComponent = ({
  analyticsChannel,
  remotePlugin,
  ErrorFallback = null,
  onEvent = NO_OP,
  ...props
}) => {
  useEffect(() => {
    return () => {
      onEvent({
        type: 'unmount'
      });
    };
  }, [onEvent]);
  const onError = useCallback(error => {
    onEvent({
      error,
      type: 'render-error'
    });
  }, [onEvent]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    analyticsChannel: analyticsChannel,
    remotePlugin: remotePlugin,
    onError: onError,
    fallback: ErrorFallback
  }, /*#__PURE__*/React.createElement(InternalRemoteComponent, _extends({
    analyticsChannel: analyticsChannel,
    remotePlugin: remotePlugin,
    onEvent: onEvent
  }, props)));
};
export default /*#__PURE__*/memo(RemoteComponent);